import React from "react";
import { Link } from "react-router-dom";
import {
  Mail,
  Phone,
  MapPin,
  ShieldCheck,
} from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#001F3F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Logo */}
          <div className="space-y-4">

            <div className="flex flex-col items-start space-y-2">

              <img
  src="/images/logo/logo1.png"
  alt="Goo More"
  className="h-12 w-auto object-contain"
/>

              <span className="text-xs font-semibold text-white">
                Resmi Alışveriş Sitesidir.
              </span>

            </div>

            <p className="text-sm text-gray-300 leading-6">
              ONE SHOP E-TİCARET KOZMETİK ÜRÜNLERİ TİCARET LTD. ŞTİ.'nin resmi sitesidir.
Siparişleriniz için resmi satış sitemiz goomorebackoffice.com üzerinden güvenli ödeme altyapısıyla alışveriş yapabilirsiniz.
            </p>

          </div>

          {/* Kurumsal */}
          <div>

            <h3 className="text-lg font-semibold mb-4">
              Kurumsal
            </h3>

            <ul className="space-y-2">

              <li>
                <Link
                  to="/"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Anasayfa
                </Link>
              </li>

              <li>
                <Link
                  to="/goomoreurunler"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Ürünleri İncele
                </Link>
              </li>

              <li>
                <Link
                  to="/sertifikalar"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Sertifikalar
                </Link>
              </li>

              <li>
                <Link
                  to="/hakkimizda"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Hakkımızda
                </Link>
              </li>

              <li>
                <Link
                  to="/iletisim"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  İletişim
                </Link>
              </li>

              <li>
                <Link
                  to="/sss"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Sık Sorulan Sorular
                </Link>
              </li>

            </ul>

          </div>

          {/* Yasal Bilgiler */}
          <div>

            <h3 className="text-lg font-semibold mb-4">
              Yasal Bilgiler
            </h3>

            <ul className="space-y-2">

              <li>
                <Link
                  to="/kvkk"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  KVKK
                </Link>
              </li>

              <li>
                <Link
                  to="/gizlilik-politikasi"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Gizlilik Politikası
                </Link>
              </li>

              <li>
                <Link
                  to="/mesafeli-satis-sozlesmesi"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Mesafeli Satış Sözleşmesi
                </Link>
              </li>

              <li>
                <Link
                  to="/on-bilgilendirme-formu"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Ön Bilgilendirme Formu
                </Link>
              </li>

              <li>
                <Link
                  to="/iade-politikasi"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  İptal ve İade Politikası
                </Link>
              </li>

              <li>
                <Link
                  to="/teslimat-politikasi"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Teslimat ve Kargo Politikası
                </Link>
              </li>

            </ul>

          </div>

          {/* İletişim */}
          <div>

            <h3 className="text-lg font-semibold mb-4">
              İletişim
            </h3>

            <ul className="space-y-4">

              <li className="flex items-start gap-3">
                <Phone size={18} className="mt-1 flex-shrink-0" />

                <span className="text-sm text-gray-300">
                  +90 537 210 14 52
                </span>
              </li>

              <li className="flex items-start gap-3">
                <Mail size={18} className="mt-1 flex-shrink-0" />

                <span className="text-sm text-gray-300 break-all">
                  goomoreinternational@gmail.com
                </span>
              </li>

             <li className="flex items-start gap-3">
  <MapPin size={18} className="mt-1 flex-shrink-0" />

  <span className="text-sm text-gray-300">
    Genç Osman Mah. Pınar Sok. No:9
    <br />
    Güngören / İstanbul
  </span>
</li>

            </ul>

          </div>

        </div>


        {/* Bottom */}

        <div className="border-t border-white/10 mt-12 pt-6">

          <div className="flex flex-col md:flex-row items-center justify-between gap-4">

            <p className="text-sm text-gray-300 text-center md:text-left">
              © {new Date().getFullYear()} Goo More. Tüm Hakları
              Saklıdır.
            </p>

          </div>

        </div>

      </div>

 
    </footer>


  );
};

export default Footer;